import { DefaultSidebar, Sidebar } from "@excalidraw/excalidraw";
import {
  presentationIcon,
} from "@excalidraw/excalidraw/components/icons";

import "./AppSidebar.scss";

export const AppSidebar = () => {
  return (
    <DefaultSidebar>
      <DefaultSidebar.TabTriggers>
        <Sidebar.TabTrigger
          tab="presentation"
        >
          {presentationIcon}
        </Sidebar.TabTrigger>
      </DefaultSidebar.TabTriggers>
      <Sidebar.Tab tab="presentation" className="px-3">
        <div className="app-sidebar-promo-container">
          <div className="app-sidebar-promo-text">
            演示模式
          </div>
        </div>
      </Sidebar.Tab>
    </DefaultSidebar>
  );
};
